module.exports = __webpack_public_path__ + "static/media/ban-khar-race.bc71d506.svg";